<template>
    <BaseModal :title="title" white v-on="$listeners">
        <div class="changelog-modal" v-html="changes" />

        <template #footer>
            <div class="l-inline l-spread l-center-v changelog-modal__footer">
                <span>{{ $t('updateHint') }}</span>

                <BaseButton size="small" @click="handleUpdate">
                    {{ $t('update') }}
                </BaseButton>
            </div>
        </template>
    </BaseModal>
</template>

<script>
import marked from 'marked'

import BaseButton from './BaseButton'
import BaseModal from './BaseModal'

import changelogDe from 'raw-loader!../../assets/notifications/user_changelog_de.md'
import changelogEn from 'raw-loader!../../assets/notifications/user_changelog_en.md'
import changelogFr from 'raw-loader!../../assets/notifications/user_changelog_fr.md'
import changelogIt from 'raw-loader!../../assets/notifications/user_changelog_it.md'

const changelogMap = {
    de: changelogDe,
    en: changelogEn,
    fr: changelogFr,
    it: changelogIt,
}

const signatureMap = {
    mobatime: 'Mobatime',
    axroad: 'adnexo',
}

export default {
    name: 'ChangelogModal',
    components: {
        BaseButton,
        BaseModal,
    },
    props: {
        showActions: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            changelog: null,
            loadingChangelog: false,
        }
    },
    computed: {
        changes() {
            const replacedMdContent = (
                this.changelog ||
                changelogMap[this.$i18n.locale] ||
                changelogMap.de
            )
                .replaceAll(
                    '${instance}',
                    signatureMap[process.env.VUE_APP_INSTANCE] ||
                        signatureMap.axroad
                )
                .replaceAll(
                    '${mail}',
                    process.env.VUE_APP_SUPPORT_EMAIL || 'support@adnexo.ch'
                )
            return marked(replacedMdContent, {
                sanitized: true,
            })
        },
        title() {
            return `${this.$t('changelogTitle')}: ${
                process.env.VUE_APP_VERSION
            }`
        },
    },
    async mounted() {
        this.loadingChangelog = true
        const lang = this.$i18n.locale || 'en'
        const subDirPath = process.env.VUE_APP_SUB_DIR_PATH
        const rootPath = subDirPath ? `/${subDirPath}` : ''
        fetch(`${rootPath}/changelogs/user_changelog_${lang || 'de'}.md`, {
            cache: 'no-store',
        })
            .then(response => response.text())
            .then(text => {
                this.changelog = text
            })
            .finally(() => {
                this.loadingChangelog = false
            })
    },
    methods: {
        handleUpdate() {
            window.location.reload()
        },
    },
}
</script>

<i18n>
{
    "en": {
        "changelogTitle": "Updates for Version",
        "update": "Reload",
        "updateHint": "Reload the page to get the latest version"
    },
    "de": {
        "changelogTitle": "Updates für Version",
        "update": "Neu laden",
        "updateHint": "Laden Sie die Seite neu, um die neueste Version zu erhalten"
    },
    "fr": {
        "changelogTitle": "Mises à jour pour la version",
        "update": "Recharger",
        "updateHint": "Recharger la page pour obtenir la dernière version"
    },
    "it": {
        "changelogTitle": "Aggiornamenti per la versione",
        "update": "Ricarica",
        "updateHint": "Ricarica la pagina per ottenere l'ultima versione"
    }
}
</i18n>

<style lang="scss">
.changelog-modal {
    p,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        margin-bottom: 16px;
    }
    li {
        margin-bottom: 8px;
    }
}
</style>
